module.exports = __webpack_public_path__ + "images/Zoom.e62751ada5a5231d4a3a91fd1e640fb7.png";